import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export type SidebarStoreType = {
  isDashSidebarOpen: boolean;
  toggleDashSidebar: () => void;
};

export const useSidebarStore = create<SidebarStoreType>()(
  persist(
    (set) => ({
      isDashSidebarOpen: true,
      toggleDashSidebar: () =>
        set((state) => ({
          isDashSidebarOpen: !state.isDashSidebarOpen,
        })),
    }),
    {
      name: "sidebar-storage", // Unique name for the storage key
      storage: createJSONStorage(() => localStorage), // Use localStorage for persistence
    }
  )
);
